import './index.scss';

import { Component, createRef, ReactNode } from 'react';

type ScrollPosition = 'start' | 'end' | 'middle' | 'none';

export type HorizontalContainerProps = {
    className?: string
    children: ReactNode
};

type HorizontalContainerState = {
    scroll: ScrollPosition
};

export default class HorizontalContainer extends Component<HorizontalContainerProps, HorizontalContainerState> {

    state: HorizontalContainerState = {
        scroll: 'none'
    };

    ref = createRef<HTMLDivElement>();

    componentDidMount() {
        window.addEventListener('resize', this.handleScroll);

        window.setTimeout(() => this.setState({ scroll: this.getScrollPosition() }), 500);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleScroll);
    }

    handleScroll = () => {
        this.setState(prevState => {
            const scroll = this.getScrollPosition();

            return prevState.scroll !== scroll ? { scroll } : null;
        });
    }

    getScrollPosition(): ScrollPosition {
        if (!this.ref.current)
            return 'none';

        // 48px de margem para mostrar a sombra, caso a diferença do scroll for pequena
        // Dependendo da resolução da tela, o `scrollLeft/Top` pode ser uma fração e, quando o scroll está no máximo, o `scrollLeft/Top` pode ser menor que `scrollWidth/Height - clientWidth/Height`,
        //     por isso, em vez de comparar se `scrollLeft/Top` é igual a `scrollWidth/Height - clientWidth/Height`, é checado a diferença, dando uma margem de 16px para mostrar/esconder a sombra

        const xDiff = this.ref.current.scrollWidth - this.ref.current.clientWidth;

        if (xDiff > 48)
            return this.ref.current.scrollLeft === 0 ? 'start' : (xDiff - this.ref.current.scrollLeft) < 16 ? 'end' : 'middle';

        const yDiff = this.ref.current.scrollHeight - this.ref.current.clientHeight;

        if (yDiff > 48)
            return this.ref.current.scrollTop === 0 ? 'start' : (yDiff - this.ref.current.scrollTop) < 16 ? 'end' : 'middle';

        return 'none';
    }

    render() {
        return (
            <div className={`horizontal-container scroll-${this.state.scroll} ${!this.props.className || ''}`}>
                <div ref={this.ref} className={this.props.className} onScroll={this.handleScroll}>{ this.props.children }</div>
            </div>
        );
    }

};
